__turbopack_context__.v({
  "className": "inter_84f418b8-module__v2CNuG__className",
  "variable": "inter_84f418b8-module__v2CNuG__variable",
});
